import React, { useState } from 'react';
import './FAQ.css'; // Assuming the updated CSS is saved here

const FAQ = () => {
  const [openFaq, setOpenFaq] = useState(null);

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  return (
    <div className="faq-container">
      <div className="faq-item" onClick={() => toggleFaq(0)}>
        <div className="faq-heading-container">
          <p className="faq-heading">1. What is Farmology?</p>
          <div className={`faq-arrow ${openFaq === 0 ? "open" : ""}`}></div>
        </div>
        {openFaq === 0 && (
          <p className="faq-text">
            Farmology is a SaaS platform designed to revolutionize farm
            management by providing end-to-end solutions for farmers. It helps
            in crop management, financial planning, market access, and
            sustainability practices.
          </p>
        )}
      </div>

      <div className="faq-item" onClick={() => toggleFaq(1)}>
        <div className="faq-heading-container">
          <p className="faq-heading">
            2. How does Farmology help with farm management?
          </p>
          <div className={`faq-arrow ${openFaq === 1 ? "open" : ""}`}></div>
        </div>
        {openFaq === 1 && (
          <p className="faq-text">
            Farmology offers tools to monitor crop health, track weather
            conditions, schedule irrigation, manage financial records, and
            connect farmers to buyers, enabling better prices and streamlined
            operations.
          </p>
        )}
      </div>

      <div className="faq-item" onClick={() => toggleFaq(2)}>
        <div className="faq-heading-container">
          <p className="faq-heading">
            3. How accurate is your app in predicting farm data?
          </p>
          <div className={`faq-arrow ${openFaq === 2 ? "open" : ""}`}></div>
        </div>
        {openFaq === 2 && (
          <p className="faq-text">
            Our app uses advanced machine learning algorithms and real-time data
            from satellites, sensors, and weather stations to provide highly
            accurate predictions for crop health, weather forecasts, and soil
            conditions. This allows farmers to make informed decisions and
            reduce risk.
          </p>
        )}
      </div>

      <div className="faq-item" onClick={() => toggleFaq(3)}>
        <div className="faq-heading-container">
          <p className="faq-heading">
            4. How can farmers increase profitability using Farmology?
          </p>
          <div className={`faq-arrow ${openFaq === 3 ? "open" : ""}`}></div>
        </div>
        {openFaq === 3 && (
          <p className="faq-text">
            Farmology helps farmers increase profitability by optimizing
            resource usage, improving crop yields through data-driven insights,
            reducing costs via efficient farm management, and providing direct
            access to buyers for better prices. It also facilitates financial
            planning and record-keeping to maximize profits.
          </p>
        )}
      </div>

      <div className="faq-item" onClick={() => toggleFaq(4)}>
        <div className="faq-heading-container">
          <p className="faq-heading">
            5. How does Farmology support sustainability?
          </p>
          <div className={`faq-arrow ${openFaq === 4 ? "open" : ""}`}></div>
        </div>
        {openFaq === 4 && (
          <p className="faq-text">
            Farmology supports sustainability by promoting efficient resource
            management practices, such as optimized irrigation and soil
            conservation. It also offers tools for eco-friendly farming and
            access to sustainable farming techniques that reduce environmental
            impact while improving productivity.
          </p>
        )}
      </div>

      <div className="faq-item" onClick={() => toggleFaq(5)}>
        <div className="faq-heading-container">
          <p className="faq-heading">
            6. How can I get started with Farmology?
          </p>
          <div className={`faq-arrow ${openFaq === 5 ? "open" : ""}`}></div>
        </div>
        {openFaq === 5 && (
          <p className="faq-text">
            Getting started with Farmology is easy. Visit our website at{" "}
            <a href="https://farmology.ai/">Farmology.ai</a>, sign up for an
            account, and create your farm profile. From there, you can access
            our full range of features and tools, as well as real-time insights
            to manage your farm more efficiently.
          </p>
        )}
      </div>
    </div>
  );
};

export default FAQ;
